import React from "react";
import Cleave from "cleave.js/react";
import "./styles.css";
import { Form, Segment, Button, Portal, Header } from "semantic-ui-react";
import { makeOrderCard } from "../../functions/Services";
import { removeAllProducts } from "../../../../redux/actions/cart";
import { makePayment } from "../../../../redux/actions/payment";
import { setCheckoutState } from "../../../../redux/actions/checkout";
import { connect } from "react-redux";
import { validateCardForm } from "../../functions/commonFunctions";
import { body } from "../../../../commons/functions/orderObjectFormat";

const CardInfo = ({
  shippingDetails,
  currencySelect,
  total,
  totalUSD,
  shippingDetails: { cardInfo },
  setCardDetails,
  setOrderNumber,
  setLoading,
  setError,
  shippingDetails: { error },
  setCheckoutState,
  history,
  // New
  makePayment,
  cart,
  subtotal,
  usdSubTotal,
  shippingCost,
}) => {
  const makeOrder = async () => {
    setLoading(true);

    try {
      let response = await makeOrderCard({
        setCheckoutState,
        shippingDetails,
        orderInfo: shippingDetails.orderInfo,
        setOrderNumber,
        total,
        totalUSD,
      });

      await makePayment(
        body({
          ...shippingDetails,
          cardInfo: {
            cardName: { value: "", error: "" },
            cardNumber: { value: "", error: "" },
            cardExpiryDate: { value: "", error: "" },
            cardCVV2: { value: "", error: "" },
          },
          subtotal,
          total,
          cart,
          shippingCost,
          origin: "preOrders",
          totalUSD,
          usdSubTotal,
          currencySelect,
        })
      );

      if (shippingDetails.cardInfo.cardNumber.value[0] === "3") {
        const authResponse = response.AuthorizeResponse;
        await saveResult(
          JSON.stringify({
            ...authResponse,
            ...authResponse.CreditCardTransactionResults,
          })
        );
      } else {
        window.myWindow = window.open("", "_self");
        window.myWindow.document.write(response);
        if (window.focus) window.myWindow.focus();
      }
    } catch (error) {
      setError(true);
    }
  };

  const saveResult = async (data) => {
    const result = JSON.parse(data);
    if (result.ResponseCode === "1") {
      if (
        result.OrderID === cardInfo.orderNumber ||
        result.OrderNumber === cardInfo.orderNumber
      ) {
        history.push(
          `/checkout/result/${result.ResponseCode}/${result.OrderNumber}/amx`
        );
      }
    } else {
      history.push(
        `/checkout/result/${result.ResponseCode}/${result.OrderNumber}`
      );
    }
    setLoading(false);
  };

  return (
    <>
      <Segment>
        <h5 className="info-contact-form-title">Información de la tarjeta</h5>
        <Form autoComplete="off">
          <Form.Input
            onChange={(e) => validateCardForm({ e, setCardDetails, cardInfo })}
            width={16}
            label={
              <label>
                Nombre en la tarjeta{" "}
                <span className="form-info-required">*</span>
              </label>
            }
            name="cardName"
            type="text"
            value={cardInfo.cardName.value}
            placeholder="Nombre en la tarjeta"
            error={
              cardInfo.cardName.error !== "" && {
                content: cardInfo.cardName.error,
                pointing: "above",
              }
            }
          />
          <label className="cleave-label">
            Número de la tarjeta <span className="form-info-required">*</span>
            <p style={{ fontSize: 10, color: "#009cda" }}>
              Ingrese solo números, sin guiones ni espacios
            </p>
          </label>
          <Cleave
            style={{
              marginBottom: "14px",
            }}
            options={{ creditCard: true }}
            onChange={(e) => {
              validateCardForm({ e, setCardDetails, cardInfo });
            }}
            width={16}
            name="cardNumber"
            // type="number"
            value={cardInfo.cardNumber.value}
            placeholder="Número de la tarjeta"
            error={
              cardInfo.cardNumber.error !== "" && {
                content: cardInfo.cardNumber.error,
                pointing: "above",
              }
            }
          />
          <Form.Group
            unstackable
            widths={2}
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div style={{ flexDirection: "column", paddingLeft: "7px" }}>
              <label className="cleave-label" style={{ marginBottom: "4px" }}>
                Fecha de vencimiento{" "}
                <span className="form-info-required">*</span>
              </label>
              <Cleave
                options={{ date: true, datePattern: ["m", "y"] }}
                onChange={(e) =>
                  validateCardForm({ e, setCardDetails, cardInfo })
                }
                name="cardExpiryDate"
                // type="number"
                value={cardInfo.cardExpiryDate.value}
                placeholder="Fecha de vencimiento de su tarjeta"
                error={
                  cardInfo.cardExpiryDate.error !== "" && {
                    content: cardInfo.cardExpiryDate.error,
                    pointing: "above",
                  }
                }
              />
            </div>
            <Form.Input
              onChange={(e) =>
                validateCardForm({ e, setCardDetails, cardInfo })
              }
              label={
                <label>
                  CVV <span className="form-info-required">*</span>
                </label>
              }
              name="cardCVV2"
              value={cardInfo.cardCVV2.value}
              type="password"
              placeholder="Valor de verificación de la tarjeta"
              error={
                cardInfo.cardCVV2.error !== "" && {
                  content: cardInfo.cardCVV2.error,
                  pointing: "above",
                }
              }
            />
          </Form.Group>
          <div className="fic-button">
            <Button
              content="Realizar pedido"
              secondary
              onClick={async () => await makeOrder()}
              disabled={
                (cardInfo.cardName.error
                  ? true
                  : cardInfo.cardName.value
                  ? false
                  : true) ||
                (cardInfo.cardNumber.error
                  ? true
                  : cardInfo.cardNumber.value
                  ? false
                  : true) ||
                (cardInfo.cardExpiryDate.error
                  ? true
                  : cardInfo.cardExpiryDate.value
                  ? false
                  : true) ||
                (cardInfo.cardCVV2.error
                  ? true
                  : cardInfo.cardCVV2.value
                  ? false
                  : true)
              }
            />
          </div>
        </Form>
        <Portal onClose={() => setError(false)} open={error}>
          <Segment
            style={{
              left: "30%",
              position: "fixed",
              top: "30%",
              zIndex: 1000,
            }}
          >
            <Header>Lo sentimos</Header>
            <p>Hubo un error al procesar su orden.</p>
            <p>
              Para mayor información, contacte al banco emisor de su tarjeta o
              revise la información de la misma.
            </p>

            <Button
              content="Intentarlo de nuevo"
              negative
              onClick={() => setError(false)}
            />
          </Segment>
        </Portal>
      </Segment>
      <div className="fic-payment-security-container">
        <div className="fic-payment-security-bancks">
          <img
            className="fic-payment-security-bancks-logos"
            src="/assets/icons/visa-secure.png"
            alt="visa-secure"
          />
          <img
            className="fic-payment-security-bancks-logos"
            src="/assets/icons/mastercard-secure.png"
            alt="mastercard-secure"
          />
        </div>

        <div className="fic-payment-security-bancks-providers">
          <img
            className="fic-payment-security-fac-logo"
            src="/assets/icons/powered-fac.png"
            alt="powered-fac"
          />
          <img
            className="fic-payment-security-fac-logo"
            src="/assets/icons/bacredomatic_logo.png"
            alt="bac"
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ cart }) => {
  return { cart: cart.cart };
};

export default connect(mapStateToProps, {
  removeAllProducts,
  makePayment,
  setCheckoutState,
})(CardInfo);
